import Alpine from 'alpinejs'
import Swiper, { Navigation, Pagination, Controller, Autoplay } from 'swiper'
import {
  CartItems,
  CartRemoveButton,
  QuantityInput,
  QuantityPopover,
  CartNote,
  ProductForm,
} from './components'
import moment from 'moment'
import 'fslightbox'
import { format, validate } from 'rut.js'

//initialize AlpineJS
window.Alpine = Alpine

//moment for global scope
window.formatRut = format
window.validateRut = validate
window.Swiper = Swiper
window.Navigation = Navigation
window.Pagination = Pagination
window.Controller = Controller
window.Autoplay = Autoplay

//moment for global scope
window.moment = moment

Alpine.data('formHandler', () => ({
  loading: false,
  complete: false,
  error: false,

  sanitizeInput(input) {
    const div = document.createElement('div')
    div.textContent = input // Escapes potential HTML/JS
    return div.innerHTML
  },
  handleSubmit(e) {
    if (this.sent) return; // Bloquea doble envío
    this.sent = true;

    e.preventDefault()

    this.loading = true
    this.complete = false
    this.error = false

    let formData = new FormData(e.target)
    let data = Object.fromEntries(formData.entries())

    // Sanitize each field
    for (let key in data) {
      data[key] = this.sanitizeInput(data[key])
    }

    fetch(
      'https://shopify-mds-func.azurewebsites.net/api/send_emails?code=CyWUUDKxr3wy-0fQ0-gnZhYjD9mBM1mGXFlPkW-zd7D1AzFuBwKZLA==',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: this.sanitizeInput(data?.name),
          email: this.sanitizeInput(data?.email),
          phone: this.sanitizeInput(data?.phone),
          rut: this.sanitizeInput(data?.rut),
          razon: this.sanitizeInput(data?.razon),
          message: this.sanitizeInput(data?.message),
          address: this.sanitizeInput(data?.address)
        })
      }
    )
      .then((response) => response.json())
      .then((result) => {
        this.complete = true
        e.target.reset()
      })
      .catch((error) => {
        console.error('Error:', err)
        this.error = true
      })
      .finally(() => {
        this.loading = false

        setTimeout(() => {
          this.complete = false
          this.error = false
          this.sent = false; // Permitir nuevo envío luego
        }, 6000)
      })

    // console.log('Form data:', data)
  }
}))

Alpine.start()

customElements.define('cart-remove-button', CartRemoveButton)
customElements.define('cart-items', CartItems)
customElements.define('quantity-input', QuantityInput)

// product form
if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm)
}

//cart note
if (!customElements.get('cart-note')) {
  customElements.define('cart-note', CartNote)
}
//quantity popover
if (!customElements.get('quantity-popover')) {
  customElements.define('quantity-popover', QuantityPopover)
}
